import { reactive } from 'vue'

export type AppConfirmVariant = 'danger' | 'warning' | 'info'

export interface AppConfirmOptions {
  title?: string
  message: string
  detail?: string
  highlight?: string
  variant?: AppConfirmVariant
  okText?: string
  cancelText?: string
  size?: 'small' | 'medium' | 'large'
  maxWidth?: string
}

export const appConfirmState = reactive({
  visible: false,
  options: null as AppConfirmOptions | null,
  resolve: null as ((value: boolean) => void) | null,
})

export function resolveAppConfirm(value: boolean) {
  const resolve = appConfirmState.resolve
  appConfirmState.visible = false
  appConfirmState.options = null
  appConfirmState.resolve = null
  resolve?.(value)
}

export function openAppConfirm(options: AppConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    appConfirmState.options = options
    appConfirmState.resolve = resolve
    appConfirmState.visible = true
  })
}
